import { Directive, HostListener, input, OnInit, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[coreNumberValue]',
  standalone: true,
})
export class NumberValueDirective implements OnInit {
  private control = inject(NgControl);

  coreNumberValue = input<boolean>(false);

  ngOnInit(): void {
    if (this.coreNumberValue()) {
      const value = this.control.control?.value;
      if (value) {
        this.control.control?.setValue(Number(value), { emitEvent: false });
      }
    }
  }

  @HostListener('input', ['$event'])
  @HostListener('blur', ['$event'])
  @HostListener('paste', ['$event'])
  @HostListener('change', ['$event'])
  onInputChange(event: Event): void {
    if (!this.coreNumberValue()) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value) {
      this.control.control?.setValue(Number(value), { emitEvent: false });
    } else {
      this.control.control?.setValue(null, { emitEvent: false });
    }
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    event.stopPropagation();
  }
}
